
// Map for Shape to Tooltype to determine what options has to be visible.
const toolMap = new Map<string, ToolType>();
toolMap.set("line", "line");
toolMap.set("polyline", "line");
toolMap.set("text", "text");
toolMap.set("circle", "circle");

function findToolToShape(toolName: string | undefined): ToolType {
  const result = toolMap.get(toolName ?? "")
  if (result !== undefined) {
    return result;
  } else {
    return "select";
  }
}

function hasValueWithKey(properyItem: GeometricShape, propertyName: string) {
  if (hasKey(properyItem, propertyName)) {
    return properyItem[propertyName] as number;
  }
  return 0;
}

function hasValueWithKeyAsAlign(properyItem: GeometricShape, propertyName: string) {
  if (hasKey(properyItem, propertyName)) {
    return properyItem[propertyName] as Align;
  }
  return "left";
}

function hasKey<O extends GeometricShape>(obj: O, key: PropertyKey): key is keyof O {
  return key in obj
}
export { findToolToShape, hasKey, hasValueWithKey, hasValueWithKeyAsAlign }